<template>
    <div class="border-bottom pb-6 mb-6">
        <div class="media align-items-center mb-2">
            <div class="u-avatar mr-3">
                <img class="img-fluid rounded-circle" src="../../public/assets/img/100x100/anonymous_user.png"
                     alt="Image Description">
            </div>
            <div class="media-body">
                <div class="d-flex justify-content-between align-items-center">
                    <span class="h6 font-weight-medium mb-0"> {{ comment.author.profile.displayName }}</span>
                    <small class="text-muted">{{ commentCreatedDisplay }}</small>
                </div>
            </div>
        </div>

        <p> {{ comment.message }}</p>

    </div>
</template>

<script>
    import {moment} from "../xlib";

    export default {
        name: "PostCommentView",
        props: ["comment"],
        computed: {
            commentCreatedDisplay: function () {
                return moment(this.comment.created).format('LLL');
            }
        }
    }
</script>

<style scoped>

</style>